import React from 'react'
import { Divider, IconButton, Paper, Stack, Typography } from '@mui/material'
import { com } from '@eidu/form'
import AndOrSelector from './AndOrSelector'
import NotSelector from './NotSelector'
import EntitySelector = com.eidu.sharedlib.entity.selector.EntitySelector
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import NonEmptyList = com.quickbirdstudios.nonEmptyCollection.list.NonEmptyList
import TargetSelectorInput from './TargetSelectorInput'
import EntitySelectorInput from './EntitySelectorInput'
import { SelectorType } from './SelectorType'

type SelectorEditorProps = {
  selector: EntitySelector
  onChange: (newSelector: EntitySelector) => void
  entityTypes: readonly EntityType[]
  selectorType: SelectorType
  enableNot?: boolean
  enableAnd?: boolean
  enableOr?: boolean
}

const SelectorEditor: React.FC<SelectorEditorProps> = ({
  selector,
  onChange,
  entityTypes,
  selectorType,
  enableNot,
  enableAnd,
  enableOr,
}) => {
  if (selector instanceof EntitySelector.Not) {
    return <NotSelector selector={selector} entityTypes={entityTypes} onChange={onChange} selectorType={selectorType} />
  } else if (selector instanceof EntitySelector.And || selector instanceof EntitySelector.Or) {
    return (
      <AndOrSelector selector={selector} entityTypes={entityTypes} onChange={onChange} selectorType={selectorType} />
    )
  } else {
    return (
      <Paper variant="outlined">
        <Stack direction="row" alignItems="center" spacing={1}>
          {selectorType === 'target' ? (
            <TargetSelectorInput entityTypes={entityTypes} entitySelector={selector} setEntitySelector={onChange} />
          ) : (
            <EntitySelectorInput entityTypes={entityTypes} entitySelector={selector} setEntitySelector={onChange} />
          )}
          <Divider />
          <Stack direction="column" alignItems="center" spacing={1} justifyContent="center">
            {enableAnd && (
              <IconButton onClick={() => onChange(new EntitySelector.And(NonEmptyList.fromArray([selector])))}>
                <Typography variant="caption">Group AND</Typography>
              </IconButton>
            )}
            {enableNot && (
              <IconButton onClick={() => onChange(new EntitySelector.Not(selector))}>
                <Typography variant="caption">NOT</Typography>
              </IconButton>
            )}
            {enableOr && (
              <IconButton onClick={() => onChange(new EntitySelector.Or(NonEmptyList.fromArray([selector])))}>
                <Typography variant="caption">Group OR</Typography>
              </IconButton>
            )}
          </Stack>
        </Stack>
      </Paper>
    )
  }
}

export default SelectorEditor
